<template>
    <div class="internal">
        <div class="container">
          <h1 class="page-header">
               <span>Mortgage
                 <span class="orange-link">Protection</span></span>
            <hr/>
          </h1>
          <div id="mortgage-protection-container">
              <p>
                Life and Critical Illness Protection is the most popular protection policy. The death of a partner is a devastating event for any family, but it could be made worse if you are left in a financially challenging situation.
              </p>
              <p>
                Life protection plans are at the centre of all risk planning, and this is the minimum you should have for your family.
              </p>
              <p>
                Cancer, heart attacks and strokes are the most common critical illnesses in the UK. The good news is that the survival rate is very high, and many people make a full recovery, but during the illness and treatment they are often unable to work, and the family can fall into huge financial difficulties.
              </p>
              <p>
                We are protection specialists with a combined 34 years’ experience and can access range of providers who can offer all types of policies to fit your budget.
              </p>
          </div>
          <div id="home-insurance-container">
              <h2>Home Insurance</h2>
              <hr />
              <p>
                Whether you’re purchasing a 1-bedroom flat or 4 bed detached, you’ll need to ensure you have buildings insurance in place to pay for any necessary repairs, should your home suffer any damage.
              </p>
              <p>
                Depending on your lender and your circumstances, buildings insurance is usually a condition of your mortgage. We can help you facilitate your buildings and contents insurance to ensure everything is in place before you get the keys to your dream home.
              </p>
          </div>
          <div class="text-center w-100" id="protection-image-container">
            <img  src="~@/assets/images/protection.png" alt="house protected image">
          </div>

      </div>
      <div class="cta">
        <div class="container">
          <div class="row d-flex align-items-center justify-content-between">
            <h2 class="mb-0 d-flex justify-content-center">
              <strong>Get In Touch</strong>
            </h2>
            <p>Whether you are wanting a face-to-face visit, zoom meeting or a quick chat over the phone to discuss your options, we can schedule a time best suited to you.</p>
            <div class="d-flex justify-content-end align-items-center">
              <router-link to="/contact-us/" class="btn btn-orange btn-block">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: "PrivacyPolicy",
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Protection.vue